// Auto-generated from package.json — do not edit manually
export const VERSION = '2.4.4';
